import {Injectable} from "@angular/core";

import {LamellaAreaObject} from "../objects-3D/lamellaAreaObject";
import {LamellaSetObject} from "../objects-3D/lamellaSetObject";
import {LamellaObject} from "../objects-3D/lamellaObject";
import {MaterialService} from "./material/material.service";
import {ResourceManagerService} from "./resource.manager.service";
import {MountingProfileObject} from "../objects-3D/mountingProfileObject";
import {FrameProfileObject} from "../objects-3D/frameProfileObject";


@Injectable({providedIn: 'root'})
    export class Object3DFactoryService {

    constructor(
        private resourceManager: ResourceManagerService,
        private materialService: MaterialService
    ) {}

    async createLamellaAreaObject(data: any): Promise<LamellaAreaObject> {
        const lamellaAreaObject = new LamellaAreaObject(data, this);

        //return lamellaAreaObject after init
        return lamellaAreaObject.init().then<LamellaAreaObject>(()=>lamellaAreaObject);
    }

    async createLamellaSetObject(data: any): Promise<LamellaSetObject> {
        const lamellaSetObject = new LamellaSetObject(data, this, this.materialService);

        //return lamellaSetObject after init
        return lamellaSetObject.init().then<LamellaSetObject>(()=>lamellaSetObject);
    }

    async createLamellaObject(data: any): Promise<LamellaObject> {
        const lamellaObject = new LamellaObject(
            data,
            this.resourceManager,
            this.materialService,
        );

        //return lamellaObject after init
        return lamellaObject.init().then<LamellaObject>(()=>lamellaObject);
    }

    async createMountingProfileObject(data: any): Promise<MountingProfileObject> {
        const mountingProfileObject = new MountingProfileObject(data, this.resourceManager, this.materialService);

        //return mountingProfileObject after init
        return mountingProfileObject.init().then<MountingProfileObject>(()=>mountingProfileObject);
    }

    async createFrameProfileObject(data: any): Promise<FrameProfileObject> {
        const frameProfileObject = new FrameProfileObject(data, this.resourceManager, this.materialService);

        //return frameProfileObject after init
        return frameProfileObject.init().then(()=>frameProfileObject);
    }

}